import { Controller } from "@hotwired/stimulus"

// Shows the mobile sticky-bottom apply bar after the user scrolls past
// `threshold` pixels from the top of the page. Idempotent — adds/removes
// `.is-visible` only when state changes.
export default class extends Controller {
  static values = { threshold: { type: Number, default: 240 } }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const visible = window.scrollY > this.thresholdValue
    if (visible === this.element.classList.contains("is-visible")) return
    this.element.classList.toggle("is-visible", visible)
  }
}
